import showErrors from "../errors/showErrors.js";

export default function() {
    this.loading = true;
    let form_data = new FormData;
    form_data.append('action', ajax_var.action_reset_password);
    form_data.append('password', this.dataInput.value);
    form_data.append('confirm_password', this.dataInput.value);
    form_data.append('key', ajax_var.r_key);
    form_data.append('user_id', ajax_var.r_id);
    form_data.append('nonce', ajax_var.nonce);

    axios.post(ajax_var.url, form_data).then((res) => {
        this.enableInputs();
        if (res.status == 200) {
            this.loading = false;

            if (typeof res.data.errors !== 'undefined') {
                this.errorMessage = 'Woops! This password reset link has already been used or is expired. Please reach out to info@gardensavvy.com for further assistance.';
            } else {
                this.carrotOpened = true;
                this.$router.push('/welcome/');
            }

        }
    })
    .catch(error => {
        showErrors.call(this, 'send reset password', error);
    });
}
